import { getDocumentBlocks } from "./documentLayout";

export function printLetterContent(content, title = "Medical Necessity Letter", { tables = false } = {}) {
  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    throw new Error("Could not open the print view. Allow pop-ups for this site and try again.");
  }
  printWindow.opener = null;
  const printDocument = printWindow.document;
  printDocument.title = title;
  const style = printDocument.createElement("style");
  style.textContent = `
    body { margin: 0; color: #000; background: #fff; }
    pre { margin: 0; white-space: pre-wrap; overflow-wrap: anywhere;
      font: 12pt/1.5 Georgia, serif; }
    table { width: 100%; border-collapse: collapse; font: 10pt/1.4 Georgia, serif; }
    th, td { border: 1px solid #777; padding: 6px; text-align: left; overflow-wrap: anywhere; }
    thead { display: table-header-group; }
    tr { break-inside: avoid; }
    @page { margin: 0.75in; }
    @media screen { body { max-width: 8in; margin: 2rem auto; padding: 1rem; } }
  `;
  const letter = printDocument.createElement(tables ? "div" : "pre");
  if (tables) {
    for (const block of getDocumentBlocks(content)) {
      if (block.text !== undefined) {
        const text = printDocument.createElement("pre");
        text.textContent = block.text;
        letter.appendChild(text);
      } else {
        const table = printDocument.createElement("table");
        const head = table.createTHead().insertRow();
        for (const value of block.headers) {
          const cell = printDocument.createElement("th");
          cell.scope = "col";
          cell.textContent = value;
          head.appendChild(cell);
        }
        const body = table.createTBody();
        for (const values of block.rows) {
          const row = body.insertRow();
          for (const value of values) row.insertCell().textContent = value;
        }
        letter.appendChild(table);
      }
    }
  } else {
    letter.textContent = String(content);
  }
  printDocument.head.appendChild(style);
  printDocument.body.replaceChildren(letter);
  printWindow.focus();
  printWindow.print();
}
